import { render, staticRenderFns } from "./dataRequest.vue?vue&type=template&id=5dbf71db&scoped=true"
import script from "./dataRequest.vue?vue&type=script&lang=js"
export * from "./dataRequest.vue?vue&type=script&lang=js"
import style0 from "./dataRequest.vue?vue&type=style&index=0&id=5dbf71db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf71db",
  null
  
)

export default component.exports